import axios from "@/config/axios";
 
const state = {
  isRejectTestLoading: false,
};
 
const getters = {
  isRejectTestLoading: (state) => state.isRejectTestLoading,
};
 
const mutations = {
  SET_LOADING(state, status) {
    state.isRejectTestLoading = status;
  },
};
 
const actions = {
  createCCRCase: async ({ commit, dispatch }, params) => {
    try {
      commit("SET_LOADING", true); // start loader
 
      const response = await axios.post("cases/create-ccr-case", params);
                   commit("SET_LOADING", false); // start loader
      return response.data;
 
    } catch (error) {
      if (error.response) {
        await dispatch("errors/errorResponse", error.response, { root: true });
      }
      throw error;
    } finally {
      commit("SET_LOADING", false); // stop loader
    }
  },
};
 
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
 
 